// extracted by mini-css-extract-plugin
export default {"modalTextUpper":"style_modalTextUpper__uOt5y","dark":"style_dark__o4hP8","light":"style_light__o48jd","red":"style_red__z6WC2","modalBtn":"style_modalBtn__4gKAE"};